import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class PeopleNotificationsService extends ServiceBase {
  static async peopleNotifications() {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/people_notification`;
    const response = await YakFetch.fetch(endpoint, 'GET');
    await PeopleNotificationsService._abortIfUnsuccessful(response);
    const peopleNotificationData = await response.json();
    return peopleNotificationData;
  }

  static async unreadCount() {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/people_notification/unread_people_notifications_count`;
    const response = await YakFetch.fetch(endpoint, 'GET');
    await PeopleNotificationsService._abortIfUnsuccessful(response);
    const unreadCountData = await response.json();
    return unreadCountData;
  }

  static async markAsRead(slug) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/people_notification/${ slug }/mark_as_read`
    const response = await YakFetch.fetch(endpoint, 'PUT');
    await PeopleNotificationsService._abortIfUnsuccessful(response);
    return true;
  }

  static async markAllAsRead() {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/people_notification/mark_all_as_read`
    const response = await YakFetch.fetch(endpoint, 'PUT');
    await PeopleNotificationsService._abortIfUnsuccessful(response);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/services/people_notifications_service.js